
import {
  defineComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  reactive,
  Ref,
  ref,
  toRefs,
} from "vue";
import { Router, useRoute, useRouter } from "vue-router";
import {
  getSpaceListApi,
  updateZanApi,
  replyChatApi,
  getUnreadApi,
  delCommentApi,
} from "../../../api/farmerSpace";
import { StateType } from "./farmerSpaceType";
import { convertSec2Str } from "../../utils/util";
import { ImagePreview, Dialog } from "vant";
import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
import Throttle from "../../utils/throttle";
import Storage from "@/storage/Storage";
import mitt from "@/utils/mitt";
import store from "@/store";
let throttle: Throttle;
function getState(): StateType {
  return {
    page: 1,
    pageSize: 10,
    dataList: [],
    videoUrl: "",
    previewVideo: false,
    dataTotal: 0,
    replyMessage: "",
    showReply: false,
    replyPlaceholder: "评论...",
    replyData: {}, // 用于保存回复对象
    recordData: {}, // 用于保存动态数据对象
    unreadData: { count: 0, lastHeadImg: "" }, //
    loading: false,
    scrollTop: 0,
    someShow: false, // 根据该值判断是否有数据菜单展开
    delSpeakobj: {
      comId: "",
      parId: "",
    },
    timer: null,
    delId: {
      comId: "",
      parId: "",
    },
    activeDelId: {
      comId: "",
      parId: "",
    },
    is1S:false
  };
}
export default defineComponent({
  components: { PreviewVideo },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const replyField = ref();
    const state = reactive<StateType>(getState());
    const { getDataList, onConfirmReply, getUnreadData } = useDatas(state);
    // 评论点赞列表页回来刷新一次
    mitt.on('updateList',()=>{
      getUnreadData()
    })
    // dom加载完成后请求数据
    nextTick(() => {
      const tempData = Storage.get("tempSpaceData");
      console.log(tempData);
      if (tempData && Object.keys(tempData).length > 0) {
        state.dataList = tempData.datas;
        // 赋值完成后直接删掉该临时数据
        Storage.remove("tempSpaceData");
      } else {
        getDataList();
      }
      // mitt.emit("onTabbarCount")
      // if(store.state.notReadObj.count !=)
    });
    // 防止上拉到底部时，多次触发调用接口
    throttle = new Throttle(500, () => {
      ++state.page;
      getDataList();
    });
    document.onkeydown = function (e) {
      // 手机软键盘按下enter键并且是在当前页面的情况下。
      if (e.key === "Enter" && route.path === "/farmerSpace") {
        onConfirmReply();
        window.scrollTo(0, state.scrollTop);
      }
    };

    document.onscroll = function () {
      // 只有在当前页面时才触发，有菜单展开展开的情况下才去循环关闭菜单
      if (route.path === "/farmerSpace" && state.someShow) {
        state.dataList.forEach((item) => (item.isShow = false));
        state.someShow = false;
      }
      state.delSpeakobj = state.activeDelId = {
        comId: "",
        parId: "",
      };
      state.is1S = false
    };
    onBeforeUnmount(() => {
      mitt.off('updateList')
      Storage.add("tempSpaceData", {
        top: document.documentElement.scrollTop || document.body.scrollTop,
        datas: state.dataList,
      });
    });

    return {
      ...useEvents(state, router, replyField),
      ...toRefs(state),
      ...toRefs(store.state),
      ...useOper(state),
      replyField,
      onConfirmReply,
    };
  },
});

// 处理数据
const useOper = (state: StateType) => {
  const { getDataList, getUnreadData } = useDatas(state);
  return {
    getZanText: function (list: Array<any>) {
      return list.map((item) => item.name).join(",");
    },
    onRefresh: function () {
      state.loading = true;
      state.page = 1;
      getDataList();
      getUnreadData();
      mitt.emit("onTabbarCount");
    },
    transfromDate: function (date: string) {
      let d = date.split(" ")[0];
      return d.replace(/-/g, ".");
    },
  };
};

// 基础事件
const useEvents = (state: StateType, router: Router, replyField: Ref) => {
  const { updateZan } = useDatas(state);
  return {
    onClickReply: function (item: any, record: any) {
      // 保存一下回复对象，在确定时需要该id
      state.replyData = item;
      // 保存一下动态的数据对象，在提交时需要该数据id
      state.recordData = record;
      state.showReply = true;
      nextTick(() => {
        state.replyPlaceholder = "回复 " + item.name;
        replyField.value.focus();
      });
      item.isShow = false;
    },
    onPreviewVideo: function (url: string) {
      state.videoUrl = url;
      state.previewVideo = true;
    },
    onPreviewImg: function (list: Array<any>, index: number) {
      ImagePreview({
        images: list.map((item) => item.url),
        startPosition: index,
      });
    },
    onFocus: function () {
      state.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
    },
    onReplyBlur: function () {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        state.showReply = false;
        state.replyMessage = "";
        window.scrollTo(0, state.scrollTop);
      }, 600);
    },
    onComment: function (item: any) {
      state.showReply = true;
      // 只是评论时清除一下回复数据，避免取到上次的id
      state.replyData = {};
      // 拿到当前评论数据，在提交时需要该数据id
      state.recordData = item;
      nextTick(() => {
        state.replyPlaceholder = "评论...";
        replyField.value.focus();
      });
      item.isShow = false;
    },
    onZan: async function (items: any) {
      updateZan(items);
    },
    onShow: function (items: any) {
      state.dataList.forEach((item) => {
        if (item.id !== items.id) {
          item.isShow = false;
        }
      });
      items.isShow = !items.isShow;
      // 有菜单被展开时，做个标识
      if (items.isShow) {
        state.someShow = items.isShow;
      }
    },
    onLoad: function () {
      throttle.search(null);
    },
    onInfo: function (item: any) {
      // 跳转页面的时候，先将当前页面的所有数据临时存到缓存中，回来后做处理
      // 主要是为了实现返回后保持位置不变的功能。这里不太建议使用keepAlive，经过测试后发现会有其他问题
      // 所以使用这种比较原始的方法来做。

      // 页面跳走时获取一下当前的scrollTop，回来后继续在当前位置

      router.push({
        path: "/infoDetail/" + item.id,
      });
    },
    onClickCount: function () {
      router.push({
        path: "/messageList",
      });
    },
    // 去资源页
    toResource(id: string) {
      router.push({
        path: "/resourceDetail/" + id,
      });
    },
    // 去农户详情
    toFarmerDetail: (id: string, type: number) => {
      // 页面跳走时获取一下当前的scrollTop，回来后继续在当前位置
      let url = "/farmerDetail";
      if (type == 0 || type == 2) {
        url = "/userDetail";
      }
      router.push({
        path: url + "/" + id,
        query: {
          type,
        },
      });
    },
    toFarmerDetailtwo: (item: any, type: number) => {
      let url = "/farmerDetail";
      let id = item.farmerId;
      if (type == 0 || type == 2) {
        id = item.createUser;
        url = "/userDetail";
      }
      router.push({
        path: url + "/" + id,
        query: {
          type,
        },
      });
    },
    // 触摸开始
    touchStart: (comId: string, parId: string, canDel: boolean) => {
      if (!canDel) {
        return;
      }
      state.activeDelId = { parId, comId };
      clearTimeout(state.timer);
      state.timer = setTimeout(() => {
        state.delSpeakobj = state.delId = { parId, comId };
        state.is1S = true
      }, 1000);
    },
    // 触摸结束
    touchEnd: (comId: string, parId: string) => {
       if(!state.is1S){
        state.activeDelId = {parId:'', comId:''}
      }
      clearTimeout(state.timer);
    },
    // 删除评论
    delCom: () => {
      Dialog.confirm({
        title: "提示",
        message: "确认删除此条评论吗？",
      })
        .then(() => {
          delCommentApi(state.delSpeakobj.comId).then((res: any) => {
            state.dataList.forEach((item: any) => {
              if (item.id == state.delSpeakobj.parId) {
                item.comments = item.comments.filter((value: any) => {
                  return value.id != state.delSpeakobj.comId;
                });
              }
            });

            state.delSpeakobj = state.activeDelId =state.delId = {
              parId: "",
              comId: "",
            };
          });
        })
        .catch(() => {
          state.delSpeakobj  = state.activeDelId = {
            parId: "",
            comId: "",
          };
        });
    },
  };
};

// 获取数据
const useDatas = (state: StateType) => {
  const getDataList = async function (itemData: any | null = null) {
    const result: any = await getSpaceListApi({
      page: (itemData && itemData.curPage) || state.page,
      pageSize: state.pageSize,
    });
    if (result.data.code === 0) {
      const data = result.data.data;
      state.dataTotal = data.total;
      let tempList = data.records.map((item: any) => {
        // 手动添加一个属性，用于记录是否展开当前数据菜单
        item.isShow = false;
        // 将数据的所在分页保存 以数据中的page优先
        item.curPage = (itemData && itemData.curPage) || state.page;
        item.videoList.forEach((videos: any) => {
          // 将视频time转为00:00格式
          videos.timeStr = convertSec2Str(videos.time);
        });
        return item;
      });
      // 分页在第一页时直接替换之前的数据
      if (state.page === 1 && !itemData) {
        state.dataList = tempList;
      } else {
        // 当外部🈶️传入具体数据时，就仅需要将新的数据替换掉以前的旧数据即可，为了实现分页数据修改时不改变位置的问题,因此直接替换对应数据
        if (itemData && Object.keys(itemData).length > 0) {
          let tempData = tempList.filter(
            (item: any) => item.id === itemData.id
          );
          // 数据存在
          if (tempData.length > 0) {
            let datas = tempData[0];
            let tempIndex = state.dataList.findIndex(
              (item) => item.id === datas.id
            );
            // 找到了渲染数组中对应的数据，将重新请求的数据替换老的数据
            if (tempIndex !== -1) {
              state.dataList.splice(tempIndex, 1, datas);
            }
          }
        } else {
          // 直接加载
          state.dataList = [...state.dataList, ...tempList];
        }
      }
    }
    state.loading = false;
  };
  return {
    getUnreadData: async function () {
      const result: any = await getUnreadApi();
        if (result.data.data) {
          store.commit('setNotRead', result.data.data)
          console.log(store.state.notReadObj);
          
        }else{
          store.commit('setNotRead',{count:0,lastHeadImg:''})
          console.log(store.state.notReadObj);
        }
    },
    updateZan: async function (item: any) {
      const result: any = await updateZanApi(item.id);
      if (result.data.code === 0) {
        getDataList(item);
      }
    },
    onConfirmReply: async function () {
      if (!state.replyMessage) {
        return;
      }
      let param: any = {
        content: state.replyMessage,
        recordId: state.recordData.id,
      };
      if (Object.keys(state.replyData).length > 0) {
        param.parentId = state.replyData.id;
      }
      const result: any = await replyChatApi(param);
      if (result.data.code === 0) {
        getDataList(state.recordData);
        state.showReply = false;
        state.replyMessage = "";
      }
    },
    getDataList,
  };
};
